import { paymentTermConstants } from "../../constants";
import { paymentTermService } from "../../services";
import { alertActions } from "../alert.actions";

export const paymentTermActions = {
  getSingleParameter,
  getAllParameters,
  addParameter,
  updateParameter,
  deleteParameter,
  clear,
};

// get single parameter
function getSingleParameter() {}

// get all parameter
function getAllParameters() {
  return (dispatch) => {
    dispatch(request());

    paymentTermService.getAllParameters().then(
      (items) => dispatch(success(items)),
      (error) => dispatch(failure(error))
    );
  };

  function request(params) {
    return { type: paymentTermConstants.GET_ALL_REQUEST, params };
  }
  function success(items) {
    return { type: paymentTermConstants.GET_ALL_SUCCESS, items };
  }
  function failure(error) {
    return { type: paymentTermConstants.GET_ALL_FAILURE, error };
  }
}

// add parameter
function addParameter(name, code) {
  return (dispatch) => {
    dispatch(request(name, code));

    paymentTermService.addParameter(name, code).then(
      (parameter) => {
        dispatch(success(parameter));
        dispatch(alertActions.success(parameter));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(parameter) {
    return { type: paymentTermConstants.ADD_REQUEST, parameter };
  }
  function success(parameter) {
    return { type: paymentTermConstants.ADD_SUCCESS, parameter };
  }
  function failure(error) {
    return { type: paymentTermConstants.ADD_FAILURE, error };
  }
}

// update parameter
function updateParameter(id, name, code) {
  return (dispatch) => {
    dispatch(request(id, name, code));

    paymentTermService.updateParameter(id, name, code).then(
      (parameter) => {
        dispatch(success(parameter));
        dispatch(alertActions.success(parameter));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(parameter) {
    return { type: paymentTermConstants.UPDATE_REQUEST, parameter };
  }
  function success(parameter) {
    return { type: paymentTermConstants.UPDATE_SUCCESS, parameter };
  }
  function failure(error) {
    return { type: paymentTermConstants.UPDATE_FAILURE, error };
  }
}

// delete parameter
function deleteParameter(id) {
  return (dispatch) => {
    dispatch(request(id));

    paymentTermService.deleteParameter(id).then(
      (parameter) => {
        dispatch(success(parameter));
        dispatch(alertActions.success(parameter));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(parameter) {
    return { type: paymentTermConstants.DELETE_REQUEST, parameter };
  }
  function success(parameter) {
    return { type: paymentTermConstants.DELETE_SUCCESS, parameter };
  }
  function failure(error) {
    return { type: paymentTermConstants.DELETE_FAILURE, error };
  }
}

// clear parameter
function clear() {
  return { type: paymentTermConstants.CLEAR };
}
